import styled from "styled-components";

export default styled.div`
  font-weight: bold;
  font-size: 1.1rem;
  color: ${p => p.theme.color.font};
  margin: 0;
  text-align: center;
`;
